import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	MaintenanceStartPayload,
	MaintenanceStartResponse,
} from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export function usePostAdviceMaintenanceStart() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<MaintenanceStartResponse, Error, MaintenanceStartPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<MaintenanceStartResponse>(
					'/advices/fertilization-plan/start-planning',
					payload,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao iniciar a recomendação de manutenção');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['maintenance'] });
		},
	});
}
